module.exports = __webpack_public_path__ + "img/ad.656c5b74.png";